'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchContentsCardSkeletonList } from '../SearchContentsCardSkeleton';
import { SearchSectionShell } from '../SearchSectionShell';
import { HometownNewsFilter } from './HometownNewsFilter';
import { HometownNewsList } from './HometownNewsList';
interface HometownNewsSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
  isFilterOpen: boolean;
  onCloseFilter: () => void;
  regionCode: string | null;
  subRegionCode: string | null;
  onRegionChange: (code: string | null) => void;
  onSubRegionChange: (code: string | null) => void;
  onReset: () => void;
}
export function HometownNewsSearch(t0) {
  const $ = _c(28);
  const {
    keyword,
    page,
    onPageChange,
    isFilterOpen,
    onCloseFilter,
    regionCode,
    subRegionCode,
    onRegionChange,
    onSubRegionChange,
    onReset
  } = t0;
  let t1;
  if ($[0] !== keyword || $[1] !== page || $[2] !== regionCode || $[3] !== subRegionCode) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/hometown-news"]({
      query: {
        searchKeyword: keyword,
        regionCode: regionCode || undefined,
        subRegionCode: subRegionCode || undefined,
        hometownNewsSort: "LATEST",
        page,
        size: PAGE_SIZE
      }
    });
    $[0] = keyword;
    $[1] = page;
    $[2] = regionCode;
    $[3] = subRegionCode;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      ...t1,
      placeholderData: keepPreviousData
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data,
    isLoading
  } = useQuery(t2);
  const t3 = data?.context?.totalCount ?? 0;
  let t4;
  if ($[7] !== t3) {
    t4 = buildPaginationMeta(t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const meta = t4;
  let t5;
  if ($[9] !== isFilterOpen || $[10] !== onCloseFilter || $[11] !== onRegionChange || $[12] !== onReset || $[13] !== onSubRegionChange || $[14] !== regionCode || $[15] !== subRegionCode) {
    t5 = <HometownNewsFilter isDrawerOpen={isFilterOpen} onCloseDrawer={onCloseFilter} onApplyDrawer={onCloseFilter} regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onRegionChange} onSubRegionChange={onSubRegionChange} onReset={onReset} />;
    $[9] = isFilterOpen;
    $[10] = onCloseFilter;
    $[11] = onRegionChange;
    $[12] = onReset;
    $[13] = onSubRegionChange;
    $[14] = regionCode;
    $[15] = subRegionCode;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== data?.context?.contents || $[18] !== isLoading) {
    t6 = isLoading ? <SearchContentsCardSkeletonList count={PAGE_SIZE} /> : <HometownNewsList items={data?.context?.contents ?? []} />;
    $[17] = data?.context?.contents;
    $[18] = isLoading;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== meta || $[21] !== onPageChange || $[22] !== page || $[23] !== t6) {
    t7 = <SearchSectionShell meta={meta} page={page} pageSize={PAGE_SIZE} onPageChange={onPageChange}>{t6}</SearchSectionShell>;
    $[20] = meta;
    $[21] = onPageChange;
    $[22] = page;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t5 || $[26] !== t7) {
    t8 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" leftAside={t5}>{t7}</DesktopPageShell>;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}